import React, { Component } from 'react'
import PropTypes from 'prop-types'

class GalleryPost extends Component {
  render() {
    return (
      <div className="gallery-post">
        <img  className="gallery-post__image"
              alt={ this.props.title }
              src={ this.props.image } />
      </div>
    )
  }
}

GalleryPost.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired
}

export default GalleryPost;



// WEBPACK FOOTER //
// ./src/components/gallery/post/index.js